import type { IconList } from '@snowit/icetypes';

import Icon from '../../Icon';
import Typo from '../../Typography/Typo';

import cx from 'classnames';
import s from './MessageIllustration.module.scss';

export interface IMessageIllustration {
  /** Add a classname to the loader */
  className?: string;
  /** Add ad id to the loader */
  id?: string;
  /** The illustration to show */
  image?: IconList;
  /** Text contained in the loader */
  text?: string;
  /** Title of the loader */
  title?: string;
}

const MessageIllustration = (props: IMessageIllustration) => {
  const { id, className, image, text, title } = props;

  const renderImg = () => {
    return (
      <Icon className={s.illustration} name={image} a11y={{ role: 'img', label: title || text }} />
    );
  };

  const renderTitle = () => {
    if (!title) return null;
    return (
      <Typo
        className={s.title}
        text={title}
        tag={'h2'}
        size={'xxl'}
        weight={'medium'}
        color={'text'}
      />
    );
  };

  const renderText = () => {
    if (!text) return null;
    return (
      <Typo
        className={s.text}
        text={text}
        tag={'p'}
        size={'df'}
        lineHeight={'paragraph'}
        color={'text-l'}
      />
    );
  };

  return (
    <div id={id} className={cx(s.wrapper, className)}>
      {renderImg()}
      {renderTitle()}
      {renderText()}
    </div>
  );
};

export default MessageIllustration;
